
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/components/Sparkbars",
      function () {
        return require("private-next-pages/components/Sparkbars.mdx");
      }
    ]);
  